import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  DeleteButton,
  TextInput,
  TopToolbar,
  CreateButton,
  ExportButton,
  SelectInput,
  useRecordContext,
} from 'react-admin'

import FilterComponent from '../../components/Filter'

const Actions = props => {
  const { resource, currentSort, filterValues, exporter, basePath } = props
  return (
    <TopToolbar>
      <CreateButton basePath={basePath} />
      <ExportButton
        disabled={false}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
        maxResults={10000}
      />
    </TopToolbar>
  )
}

const PlaylistFilter = props => (
  <FilterComponent {...props}>
    <TextInput label="Search by name" source="name" alwaysOn />
    <SelectInput
      label="Status"
      source="status"
      choices={[
        { id: 'active', name: 'Active' },
        { id: 'inactive', name: 'Inactive' },
        { id: 'draft', name: 'Draft' },
      ]}
    />
  </FilterComponent>
)

const ActionField = () => {
  const record = useRecordContext()
  if (!record) return null

  return <DeleteButton label="Delete" record={record} undoable={false} />
}

const PlaylistList = ({ ...props }) => {
  return (
    <List
      {...props}
      filters={<PlaylistFilter />}
      actions={<Actions />}
      sort={{ field: 'updatedAt', order: 'DESC' }}
      filter={{ type: 'internal' }}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="status" />
        <TextField source="type" />
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
        <EditButton />
        <ActionField />
      </Datagrid>
    </List>
  )
}

export default PlaylistList
